import React from 'react';
import styles from "../css/Opportunity.module.css";
import Banner from "../components/Banner";
import { Button } from "../components";
import project from "../assets/projectcard/project.jpg";

export const Opportunity = () => {
  return (
    <div className={styles.opportunity}>
      <Banner heading = "Offer an Opportunity"/>
      <div className={styles.content}>
        <div className={styles.info}>
          <div className={styles.instructions}>
            <h1>Instructions and Options</h1>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut 
              labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate 
              velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident
              ,sunt in culpa qui officia deserunt mollit anim id est laborum Sed ut perspiciatis unde omnis
              iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque
              ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.
              Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia 
              consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam
              est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam
              eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad
              minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut 
              aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea 
              voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat 
              quo voluptas nulla pariatur</p>
          </div>
          <div className={styles.brochure}>
            <img src={project}/>
          </div>
        </div>
        <div className={styles.boxes}>
          <div>
            <Button text="Internship"/>
          </div>
          <div>
            <Button text="Interact with talent"/>
          </div>
          <div>
            <Button text="Placement"/>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Opportunity